export const generateRecaptchaToken = async (siteKey: string, action: string): Promise<string | null> => {
  try {
    return (await window.grecaptcha?.enterprise?.execute?.(siteKey ?? '', { action })) ?? '';
  } catch (err) {
    console.error('Error generating reCaptcha token.');
    return null;
  }
};
